import { useCallback } from 'react';

import { getDefaultAddress, putDefaultAddress } from 'common/api/crm/family/address';
import { useApi } from 'common/modules/async-actions/useApi';
import { FamilyAddress } from 'common/api/crm/family/address/models/FamilyAddress';

export const useDefaultAddress = () => {
    const [doGetDefaultAddress, defaultAddressesAsyncState, defaultAddressResult] =
        useApi(getDefaultAddress);

    const defaultAddress =
        (defaultAddressResult && (defaultAddressResult.data as FamilyAddress)) || null;

    const refreshDefaultAddress = useCallback(async () => {
        const response = await doGetDefaultAddress();

        if (response.error) {
            return false;
        }

        return true;
    }, [doGetDefaultAddress]);

    const setDefaultAddress = async (familyAddress: FamilyAddress) => {
        const response = await putDefaultAddress(familyAddress.id);

        if (response.error) {
            return false;
        }
        refreshDefaultAddress();
        return true;
    };

    const isDefaultAddress = useCallback(
        (address: FamilyAddress) => {
            if (!defaultAddress) {
                return null;
            }
            return defaultAddress.id === address.id;
        },
        [defaultAddress]
    );

    return {
        defaultAddress,
        refreshDefaultAddress,
        defaultAddressesAsyncState,
        setDefaultAddress,
        isDefaultAddress,
    };
};
